import styles from './colour-options.module.scss'

export const ColourOptionsAlert = () => {
  return (
    <div className={styles.information}>
      <div>
        <p><strong>Important: </strong>Colour options subject to availability and may carry an additional cost</p>
      </div>
    </div>
  )
}
